import { Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { Currency } from '@app/model/currency';
import {
  AttachmentData,
  LineItem,
} from '@app/model/payment-request/payment-request.dto';

@Component({
  selector: 'app-selector',
  templateUrl: './selector.component.html',
  styleUrls: ['./selector.component.scss'],
})
export class SelectorComponent implements OnInit, OnChanges {
  @Input() title: string;
  @Input() selectorItems: SelectorItem[];
  @Input() selectedItem: SelectorItem;
  @Input() iconUrl: Link;
  @Input() onOpenTerms: () => void;
  @Input() isDiscountedInterestRate: boolean = false;


  constructor() {}

  ngOnInit(): void {
    if (!this.selectedItem) {
      this.selectedItem = this.selectorItems[0];
    }
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['selectedItem'] && changes['selectedItem'].currentValue) {
      this.selectedItem = changes['selectedItem'].currentValue;
    }
  }

  public selectItemByTab(tab: string) {
    this.setSelectedItem(this.selectorItems.find((item) => item.tab === tab));
  }

  setSelectedItem(selectedItem) {
    this.selectedItem = selectedItem;
  }

  validateThenOpenAttachmentInNewWindow(attachment: AttachmentData): void {
    /** NB: When authentication and/or documents are added to this "payment attachments" feature
     * then attachment.authentications must be checked and handled before opening the resource */
    window.open(attachment.url, '_blank');
  }
}

export interface SelectorItem {
  tab: string;
  title: string;
  descriptions?: Description[];
  lineItems?: LineItem[];
  totalValue?: string;
  links?: Link[];
  attachments?: AttachmentData[];
}

interface Description {
  title?: string;
  text?: string;
  subItems?: SubItem[];
}

export interface SubItem {
  title: string;
  amount: Currency;
}

export interface Link {
  text: string;
  onClick: () => void;
  iconUrl?: string;
}
